<template>
<div>
  <fade-in>
    <p class="work-contents-text">{{ webSiteText }}</p>
  </fade-in>
  <fade-in>
    <p class="work-contents-text">{{ webSiteTextContentsFirst }}</p>
  </fade-in>
  <fade-in>
    <p class="work-contents-text">{{ webSiteTextContentsSecound }}</p>
  </fade-in>
</div>
</template>

<script>
import FadeIn from '@/components/FadeIn.vue';

export default {
 props: ['webSiteText','webSiteTextContentsFirst','webSiteTextContentsSecound'],
  components: {
    FadeIn
  }
}
</script>

<style lang="scss" scoped>
.work-contents-text {
  margin-top: 100px;
}
</style>